import DeviceSelector from "components/device-selector/device-selector";
import { SelectedProduct } from "routes/guide-details/guide-details";

interface NewGuideDescriptionCardProps {
	description?: string;
	onDescriptionChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
	selectedDevices?: SelectedProduct[];
	onDeviceSelect?: (values: SelectedProduct[]) => void;
	onNext?: () => void;
	handoverId?: string;
}

// give all props a default value
const NewGuideDescriptionCard = ({
	description = "",
	onDescriptionChange = () => {},
	selectedDevices = [],
	onDeviceSelect = () => {},
	onNext = () => {},
	handoverId = ""
}: NewGuideDescriptionCardProps) => {
	return (
		<div className="new-guide-description-card">
			<div className="new-guide-description-card-title">
				Let's create a Guide.
				<div className="new-guide-description-card-sub">
					Turn any video into a how-to guide for operation, maintenance, or troubleshooting. Thanks to some AI magic,
					this will only take a minute!
				</div>
			</div>

			<div>
				<div className="new-guide-description-card-section-title">
					First, provide a brief description of what the Guide will cover.
				</div>
				<label className="new-guide-description-card-label" htmlFor="guide-description">
					Description
				</label>
				<textarea
					id="guide-description"
					className="new-guide-description-card-textarea"
					placeholder="e.g., How to use the access control system and test a tenant’s FOB."
					value={description}
					onChange={onDescriptionChange}
					rows={4}
				/>
			</div>

			<DeviceSelector selectedDevices={selectedDevices} onDeviceSelect={onDeviceSelect} />

			<div className="new-guide-description-card-actions-row">
				<button type="button" className="highnote-button" disabled={!description} onClick={onNext}>
					Next
				</button>
			</div>
		</div>
	);
};

export default NewGuideDescriptionCard;
